import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutMe } from './components/AboutMe';
import { WhoIHelp } from './components/WhoIHelp';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { BrandAssets } from './components/BrandAssets';
export function App() {
  const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : '');
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (hash === '#brand-assets') {
    return <BrandAssets data-id="element-0" data-mp="23u9ueosaffxt" />;
  }
  return <div className="min-h-screen bg-offwhite-50 font-sans selection:bg-amber-500/30 selection:text-charcoal-950" data-id="element-1" data-mp="23v2uj6wqr76z">
      <Navbar data-id="element-2" data-mp="3ii4ro0w5cqo1" />
      <main data-id="element-3" data-mp="3mlawr57iwbsx">
        <Hero data-id="element-4" data-mp="3ml12h5fg3ihf" />
        <AboutMe data-id="element-5" data-mp="3mkhm3t5g125i" />
        <WhoIHelp data-id="element-6" data-mp="3mjzrt22ccy08" />
        <Approach data-id="element-7" data-mp="3mjg8bgx1m1k3" />
        <Services data-id="element-8" data-mp="3rc9dg5wfbbwp" />
        <Testimonials data-id="element-9" data-mp="3rbrbqtqzs5he" />
        <CTASection data-id="element-10" data-mp="3rdkhm6ts6loc" />
      </main>
      <Footer data-id="element-11" data-mp="3reccfffk0fdk" />
    </div>;
}